/**
 * Always-visible scroll indicator for the popup cart item list.
 *
 * Native scrollbars auto-hide on iOS and overlay-scrollbar systems, so
 * shoppers don't realise the list scrolls. This draws a passive indicator
 * that is visible as soon as the popup opens. It never intercepts input
 * (pointer-events: none) — scrolling still happens natively on the list.
 */
(function () {
  'use strict';

  var LIST_SELECTOR = '.popup-cart__items';

  function getLists() {
    return Array.prototype.slice.call(document.querySelectorAll(LIST_SELECTOR));
  }

  function ensureList(list) {
    if (!list) return;

    if (list.scrollHeight <= list.clientHeight + 2) {
      if (list._scrollTrack) {
        list._scrollTrack.remove();
        list._scrollTrack = null;
      }
      return;
    }

    var track = list._scrollTrack;
    if (!track || !track.isConnected) {
      track = document.createElement('div');
      track.className = 'cart-items-scrollbar';
      track.setAttribute('aria-hidden', 'true');
      var thumb = document.createElement('div');
      thumb.className = 'cart-items-scrollbar__thumb';
      track.appendChild(thumb);

      var parent = list.parentElement;
      if (!parent) return;
      if (getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      parent.appendChild(track);
      list._scrollTrack = track;
      list.addEventListener('scroll', function () {
        updateList(list);
      }, { passive: true });
    }
    updateList(list);
  }

  function updateList(list) {
    if (!list || !list._scrollTrack || !list._scrollTrack.isConnected) return;

    var track = list._scrollTrack;
    var parent = list.parentElement;
    if (!parent) return;
    var parentRect = parent.getBoundingClientRect();
    var rect = list.getBoundingClientRect();

    track.style.top = (rect.top - parentRect.top) + 'px';
    track.style.height = rect.height + 'px';

    var thumb = track.firstElementChild;
    var ratio = list.clientHeight / list.scrollHeight;
    var thumbHeight = Math.max(rect.height * ratio, 24);
    var maxOffset = rect.height - thumbHeight;
    var scrollable = list.scrollHeight - list.clientHeight;
    var progress = scrollable > 0 ? list.scrollTop / scrollable : 0;

    thumb.style.height = thumbHeight + 'px';
    thumb.style.transform = 'translateY(' + (maxOffset * progress) + 'px)';
  }

  function ensureAll() {
    getLists().forEach(ensureList);
  }

  function updateAll() {
    getLists().forEach(updateList);
  }

  function init() {
    var observer = new MutationObserver(function () {
      ensureAll();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });

    window.addEventListener('resize', updateAll);
    ensureAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
